import { useOrganizationDetail } from "@/api/services/admin/organization";
import { Button } from "@/components/elements/Button";
import { SectionCard } from "@/components/elements/SectionCard";
import { SegmentedControl } from "@/components/elements/SegmentedControl/SegmentedControl";
import { StickyFooter } from "@/components/elements/StickyFooter/StickyFooter";
import { EOrganizationStatus } from "@/constants/enum";
import { AdminUserTable } from "@/features/organization/components/organization-detail/user-table/AdminUserTable";
import { OrganizationUserTable } from "@/features/organization/components/organization-detail/user-table/OrganizationUserTable";
import { USER_TYPE_KEYS, USER_TYPE_OPTIONS } from "@/features/organization/constants/organizationDetail";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

export const OrganizationDetailUserList: FC = () => {
  const navigate = useNavigate();

  const { data: organization } = useOrganizationDetail();

  const [userType, setUserType] = useState<string>(USER_TYPE_KEYS.ORGANIZATION);
  const [orgUserTotal, setOrgUserTotal] = useState<number | undefined>();
  const [adminUserTotal, setAdminUserTotal] = useState<number | undefined>();

  const handleOrgUserTotalChange = useCallback((total: number) => setOrgUserTotal(total), []);
  const handleAdminUserTotalChange = useCallback((total: number) => setAdminUserTotal(total), []);

  const currentTotal = userType === USER_TYPE_KEYS.ORGANIZATION ? orgUserTotal : adminUserTotal;

  const isDeleted = organization?.data?.status === EOrganizationStatus.DELETED;

  const handleBack = () => {
    navigate(AppRoutes.organizations);
  };

  return (
    <>
      <SectionCard
        maxWidth="100%"
        title={
          <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="head20Bold" color={black[30]}>
              ユーザーの一覧{currentTotal != null ? `(${currentTotal})` : ""}
            </Typography>
            <SegmentedControl value={userType} options={USER_TYPE_OPTIONS} onChange={setUserType} />
          </Stack>
        }
      >
        {userType === USER_TYPE_KEYS.ORGANIZATION && <OrganizationUserTable onTotalChange={handleOrgUserTotalChange} readOnly={isDeleted} />}
        {userType === USER_TYPE_KEYS.ADMIN && <AdminUserTable onTotalChange={handleAdminUserTotalChange} />}
      </SectionCard>
      <StickyFooter
        sx={{
          mt: "32px",
        }}
      >
        <Stack width="100%" justifyContent="flex-start" flexDirection="row">
          <Button size="sm" variant="ghost" onClick={handleBack}>
            戻る
          </Button>
        </Stack>
      </StickyFooter>
    </>
  );
};
